import React, { useState, useEffect } from 'react';
import Modal from 'react-responsive-modal';
import Select from 'react-select';
import api from '../../../config/axios';
import useForm from 'react-hook-form';
import { toast } from 'react-toastify';

const subscriptionTypes = [
    { id: 'prepago', name: 'Pago adelantado' },
    { id: 'regalo', name: 'Regalo' },
    { id: 'intercambio_club_puntos', name: 'Intercambio de club puntos' },
];

const ModalSubscription = ({ open, onClose, franchiseId, clientId }) => {
    const [paymentMethods, setPaymentMethods] = useState([]);
    const { register, handleSubmit, errors, setValue, clearError } = useForm();
    const [state, setState] = useState({
        type: 'prepago',
        paymentMethodId: null,
        quantity: 0,
        note: '',
        payment_confirmation_id: null,
    });
    const [loading, setLoading] = useState(false);

    const fetchPaymentMethods = async () => {
        const { data } = await api.get(`/franchise/${franchiseId}/payment_method`);
        const paymentMethods = data.data;

        return paymentMethods;
    };

    const createSubscription = async (dataForm) => {
        setLoading(true);
        try {
            await api.post(`/client/${clientId}/subscription`, dataForm);
            setLoading(false);
            onClose();
            toast.success('Subscripción creada correctamente');
            setTimeout(() => {
                window.location.reload();
            }, 1500);
        } catch (error) {
            setLoading(false);
            toast.error('Error al crear la subscripción');
        }
    };

    useEffect(() => {
        fetchPaymentMethods().then((paymentMethods) => {
            setPaymentMethods(paymentMethods);
        });
    }, [franchiseId]);

    const handleChange = (e) => {
        setState({ ...state, [e.target.name]: e.target.value });
    };

    const handleSelectOption = (field, value) => {
        setValue(field, value);
        clearError(field);
    };

    return (
        <Modal open={open} center onClose={onClose}>
            <div className="modal-header">
                <h5 className="modal-title f-w-600">Crear subscripción</h5>
            </div>
            <div className="modal-body">
                <div className="row product-adding">
                    <div className="col-xl-10 offset-xl-1">
                        <div className="needs-validation add-product-form">
                            <div className="form form-label-center">
                                <div className="form-group mb-4 row">
                                    <p>
                                        Agregar recargas a favor al cliente. Ya sea por pago
                                        adelantado, regalo o intercambio de club puntos.
                                    </p>
                                </div>
                                <div className="form-group mb-4 row">
                                    <div className="col-12">
                                        <Select
                                            name="type"
                                            placeholder="Tipo de subscripción"
                                            onChange={(value) =>
                                                handleSelectOption('type', value.id)
                                            }
                                            options={subscriptionTypes.map((subscriptionType) => {
                                                return {
                                                    ...subscriptionType,
                                                    value: subscriptionType.id,
                                                    label: subscriptionType.name,
                                                };
                                            })}
                                            isSearchable={false}
                                            ref={() =>
                                                register(
                                                    {
                                                        name: 'type',
                                                        type: 'custom',
                                                    },
                                                    {
                                                        required: true,
                                                    },
                                                )
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="form-group mb-4 row">
                                    <div className="col-12">
                                        <Select
                                            name="paymentMethodId"
                                            placeholder="Forma de pago"
                                            onChange={(value) =>
                                                handleSelectOption('paymentMethodId', value.id)
                                            }
                                            options={paymentMethods.map((paymentMethod) => {
                                                return {
                                                    ...paymentMethod,
                                                    value: paymentMethod.id,
                                                    label: paymentMethod.name,
                                                };
                                            })}
                                            isSearchable={false}
                                            ref={() =>
                                                register(
                                                    {
                                                        name: 'paymentMethodId',
                                                        type: 'custom',
                                                    },
                                                    {
                                                        required: true,
                                                    },
                                                )
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="form-group mb-4 row">
                                    <div className="col-xl-12">
                                        <input
                                            type="number"
                                            className="form-control"
                                            placeholder="Cantidad recargas a favor"
                                            name="quantity"
                                            value={state.quantity}
                                            onChange={handleChange}
                                            ref={register({
                                                required: true,
                                            })}
                                        />
                                        {errors.quantity && errors.quantity.type === 'required' && (
                                            <p className="message-error-input">
                                                Este campo es obligatorio
                                            </p>
                                        )}
                                    </div>
                                </div>
                                <div className="form-group mb-4 row">
                                    <div className="col-xl-12">
                                        <input
                                            type="number"
                                            className="form-control"
                                            placeholder="ID de la transacción"
                                            name="payment_confirmation_id"
                                            value={state.payment_confirmation_id}
                                            onChange={handleChange}
                                            ref={register({
                                                required: false,
                                            })}
                                        />
                                    </div>
                                </div>
                                <div className="form-group mb-4 row">
                                    <div className="col-xl-12">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Nota de la subscripción"
                                            name="note"
                                            value={state.note}
                                            onChange={handleChange}
                                            ref={register({
                                                required: false,
                                            })}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleSubmit(createSubscription)}
                    disabled={loading}
                >
                    {loading ? 'Guardando...' : 'Guardar'}
                </button>
            </div>
        </Modal>
    );
};

export default ModalSubscription;
